export enum WebhookStatus {
  UNSET_WEBHOOK_STATUS = 'UNSET_WEBHOOK_STATUS', // Do not use, needed because of proto3 limitations
  ACTIVATED = 'ACTIVATED',
  PAUSED = 'PAUSED',
  DELETED = 'PAUSED',
}
